export default __webpack_public_path__ + "static/media/d3a4d8a3ffb659efb1c681318c66d739.png";